module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"service-info":"Info","found":"found {count} more","check":"Check"},"ua":{"service-info":"Info","found":"знайдено ще {count}","check":"Перевірити"},"ru":{"service-info":"Info","found":"найдено еще {count}","check":"Проверить"}}')
  delete Component.options._Ctor
}
